import { render, staticRenderFns } from "./cxt-Footer.vue?vue&type=template&id=23d88e32&scoped=true&"
import script from "./cxt-Footer.vue?vue&type=script&lang=js&"
export * from "./cxt-Footer.vue?vue&type=script&lang=js&"
import style0 from "./cxt-Footer.vue?vue&type=style&index=0&id=23d88e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d88e32",
  null
  
)

export default component.exports